export default "__VITE_ASSET__DjPhSrxm__"